import React from 'react';
import PropTypes from 'prop-types';
import Title from 'components/Title';
import CustomSelect from 'components/CustomSelect';
import ButtonFilter from 'components/ButtonFilter';

import styles from './styles.module.scss';

const sortOptions = [
	{ title: 'По популярности', value: '-views' },
	{ title: 'По дате добавления', value: '-publishDate' }
];

const CatalogHeading = ({
	title,
	handleSort,
	urlParams,
	subtitle,
	moreControl,
	className
}) => {
	const selectedValue = urlParams.sort || '-views';
	const sorting = handleSort && (
		<div className={styles.control}>
			<CustomSelect
				name="sort"
				options={sortOptions}
				onChange={handleSort}
				selectedValue={selectedValue}
				align="right"
				resetOption={null}
				defaultTitle="Упорядочить по"
				ariaLabel="Выбор сортировки"
				controlElement={
					<ButtonFilter
						iconPosition="right"
						icon="catalogChevronDown"
						size="mobileSmall"
						data-aria-id="sort"
						ariaHideTextNode
					/>
				}
				valueField="value"
			/>
		</div>
	);

	const more = moreControl && (
		<div className={styles.control}>
			<Title
				text={moreControl.title}
				url={moreControl.url}
				as={moreControl.as}
				theme="more"
			/>
		</div>
	);

	return (
		<div className={className}>
			<span className={styles.title}>
				<Title className={styles.mainTitle} text={title} Tag="h1" />
				{subtitle && <Title text={subtitle} ariaHidden />}
			</span>
			{sorting}
			{more}
		</div>
	);
};

CatalogHeading.propTypes = {
	className: PropTypes.string,
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
	handleSort: PropTypes.func,
	urlParams: PropTypes.object,
	moreControl: PropTypes.shape({
		title: PropTypes.string.isRequired,
		url: PropTypes.string.isRequired,
		as: PropTypes.string
	})
};

export default CatalogHeading;
